<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Tickets
            <add-button link="/main/tickets/create"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Tickets</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Ticket Type</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Follow Ups</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="5"></loading-table>
                      <router-link 
                        v-for="(ticket, at) in tickets"
                        :key="`ticket${at}`"
                        :to="`/main/tickets/${ticket.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ ticket.ticket_type ? ticket.ticket_type.code : '' }}</td>
                        <td>{{ ticket.description }}</td>
                        <td>{{ ticket.status == 0 ? 'OPEN' : 'CLOSED' }}</td>
                        <td>
                          <add-button :link="`/main/tickets/${ticket.id}/follow-ups`"></add-button>
                        </td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'tickets',
  data () {
    return {
      tickets: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
    // this.getMasters()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let tickets = await axios.get(`tickets?page=${page}&rowsPerPage=${this.rowsPerPage}`)
      // console.log(tickets)
      this.tickets = tickets.data.data
      this.count = tickets.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    },
    // async getMasters() {
    //   let masters = await axios.get('tickets/masters')
    //   masters = masters.data
    // },
  }
}
</script>